import { createColumnHelper } from '@tanstack/react-table';
import { EET } from '../utils/types';
import Checkbox from '@mui/material/Checkbox';
import HeaderCellCheckbox from '../../../../components/common/primebmd-ui/HeaderCellCheckbox';
import moment from 'moment';

const columnHelper = createColumnHelper<EET>();

const EETColumns = [
    columnHelper.display({
        id: 'select',
        header: ({ table }) => (
        <HeaderCellCheckbox
            checked={table.getIsAllRowsSelected()}
            indeterminate={table.getIsSomeRowsSelected()}
            onChange={table.getToggleAllRowsSelectedHandler()}
        />
        ),
        cell: ({ row }) => (
        <Checkbox
            checked={row.getIsSelected()}
            indeterminate={row.getIsSomeSelected()}
            onChange={row.getToggleSelectedHandler()}
        />
        ),
    }),
    columnHelper.accessor('ejoNumber', {
        id: 'ejoNumber',
        header: 'MRRF Number',
        cell:  (row) => row.getValue(),
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('ejoCreatedDate', {
        id: 'ejoCreatedDate',
        header: 'MRRF Creation Date',
        cell: (row) => row.getValue() !== '' ? moment(row.getValue()).format('MM/DD/yyyy'): '-',
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('ejoApprovalDate', {
        id: 'ejoApprovalDate',
        header: 'MRRF Approval Date',
        cell: (row) => row.getValue() !== '' ? moment(row.getValue()).format('MM/DD/yyyy'): '-',
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('esrNumber', {
        id: 'esrNumber',
        header: 'JO Number',
        cell:  (row) => row.getValue(),
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('esrCreatedDate', {
        id: 'esrCreatedDate',
        header: 'JO Creation Date',
        cell: (row) => row.getValue() !== '' ? moment(row.getValue()).format('MM/DD/yyyy'): '-',
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('dateNeeded', {
        id: 'dateNeeded',
        header: 'JO Date Needed',
        cell: (row) => row.getValue() !== '' ? moment(row.getValue()).format('MM/DD/yyyy'): '-',
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('esrApprovalDate', {
        id: 'esrApprovalDate',
        header: 'JO Approval Date',
        cell: (row) => row.getValue() !== '' ? moment(row.getValue()).format('MM/DD/yyyy'): '-',
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('esrStartDate', {
        id: 'esrStartDate',
        header: 'JO Start Date',
        cell: (row) => row.getValue() !== '' ? moment(row.getValue()).format('MM/DD/yyyy'): '-',
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('esrCompletionDate', {
        id: 'esrCompletionDate',
        header: 'JO Completion Date',
        cell: (row) => row.getValue() !== '' ? moment(row.getValue()).format('MM/DD/yyyy'): '-',
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('serviceRequest', {
        id: 'serviceRequest',
        header: 'JO Service Request',
        cell: (row) => row.getValue() !== '' ? row.getValue() : '-',
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('remarks', {
        id: 'remarks',
        header: 'JO Remarks',
        cell: (row) => row.getValue() !== '' ? row.getValue() : '-',
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('equipmentNumber', {
        id: 'equipmentNumber',
        header: 'Equipment No',
        cell:  (row) => row.getValue(),
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('model', {
        id: 'model',
        header: 'Model',
        cell:  (row) => row.getValue(),
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('productFamily', {
        id: 'productFamily',
        header: 'Product Family',
        cell:  (row) => row.getValue(),
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('make', {
        id: 'make',
        header: 'Make',
        cell:  (row) => row.getValue(),
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('project', {
        id: 'project',
        header: 'Project',
        cell:  (row) => row.getValue(),
        enableGlobalFilter: true,
        enableColumnFilter: true,
    }),
    columnHelper.accessor('ownedOrRented', {
        id: 'ownedOrRented',
        header: 'Ownership Type',
        cell:  (row) => row.getValue(),
        enableGlobalFilter: true,
        enableColumnFilter: true,
    })
];

export default EETColumns;